import React, { Component } from 'react'
import { Table, Row, Select, DatePicker } from 'antd'
import InboxItem from '../../components/inbox_item';
import Title from 'antd/lib/typography/Title';
import { withDomains, RESTExecutor } from '../../lib/domain'
import moment from 'moment';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import FilterFixedInput from '../../components/filter_fixed_input';
import NetworkSelect from '../../lib/ui/network_select';
import { reports_quick_menu } from '../../util/ui_util';
import CustomDateRangePicker from '../../components/custom_date_range';
import {defaultDateFormat, formatMoney} from '../../lib/util';


const queryString = require('query-string');

const inbox_cols = ({ onRefresh }) => [{
    key: 'inbox',
    render: (data) =>{
    return {
        children:<InboxItem data={data} key={`${data.id}-${data.seen}`} onRefresh={onRefresh} />,

        }
        }
}]

class ReportInbox extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filter_query: {
                per_page: 100,
                page: 1
            }
        };

        this.list_reports = RESTExecutor.list().config({
            label: 'inbox_list',
            params: {
                per_page: 100,
                page: 1
            }
        }).connect(props.domains.reports)



    };
    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        let list_reports_resp = this.list_reports.response();


        let rowsData = (list_reports_resp.result && list_reports_resp.result.rows) || [];
        let rowsMeta = list_reports_resp.meta || {};

        const { filter_query } = this.state;
        return (
            <div>
                <BasicHeader no_back title="Inbox"
                    menu_items={reports_quick_menu}
                />
                <div className='filter-card'>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        // justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        paddingTop: 4, paddingBottom: 4
                    }}>
                        <FilterFixedInput label="Date Range" >
                            <CustomDateRangePicker
                                style={{
                                    // width: 400,
                                    // marginLeft: 16,
                                    flex: null
                                }}
                                allowClear
                                startDate={filter_query.dateFrom ? moment(filter_query.dateFrom, defaultDateFormat) : null}
                                endDate={filter_query.dateTo ? moment(filter_query.dateTo, defaultDateFormat) : null}
                                onChange={(dates) => {
                                    //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                                    this.stateUpdater({
                                        stateKey: 'filter_query', appendObj: {
                                            dateFrom: dates.startDate?dates.startDate.format(defaultDateFormat):undefined,
                                            dateTo: dates.endDate?dates.endDate.format(defaultDateFormat):undefined,page: 1
                                        },
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify(this.state.filter_query)
                                            })
                                        }
                                    })
                                }}

                            />
                        </FilterFixedInput>
                        <FilterFixedInput label="Plugin" >
                            <NetworkSelect
                                value={filter_query.plugin_id}
                                // style={{ marginRight: 8 }}
                                item={{ name: "Report Plugins", className: filter_query.plugin_id != null ? 'filter-option-selected' : '' }}
                                url={`/report-plugins`}
                                onChange={(received_value) => {
                                    this.stateUpdater({
                                        stateKey: 'filter_query',
                                        valueKey: 'plugin_id',
                                        value: received_value,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                        }
                                    })
                                    // this._change(item.index, received_value, d_key)
                                }}
                            // renderItem={(data)=>{
                            //     // console.log("data",data)
                            //     let ref = data.__references__ || {};
                            //     let source = ref.source_id || {};
                            //     return source.name
                            //   }}

                            />
                        </FilterFixedInput>
                    </div>
                </div>

                <ErrorWrapper
                    error={list_reports_resp}
                    onReload={() => {
                        this.list_reports.execute();
                    }}
                >
                    <div className='default-card' style={{ padding: 0 }}>
                        <Table
                            scroll={{ x: true }}
                            loading={list_reports_resp.fetching}
                            size='small'
                            rowKey={(record, index) => `${index}-`}
                            bordered={false}
                            pagination={{
                                // simple: true,
                                position: 'bottom',
                                onChange: (current, size) => {
                                    this.props.history.push({
                                        search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                    })
                                },
                                defaultCurrent: 1,
                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                // defaultPageSize: 20,
                                pageSize: (rowsMeta && rowsMeta.requested_count),

                                total: (rowsMeta && rowsMeta.total_count),
                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                            }}
                            className=' no-padding-table-reports main-table'
                            showHeader={false}
                            columns={inbox_cols({
                                onRefresh: () => {
                                    this.list_reports.execute()
                                }
                            })}
                            dataSource={rowsData}
                        />
                    </div>
                </ErrorWrapper>
            </div>
        )
    }
    componentDidMount() {
        this.list_reports.execute();
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_reports.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })
    }
    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_reports.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }
}

export default withDomains(ReportInbox, "reports");
